import * as React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
// components
import { PopoverModal } from 'components/UI'
// constants
import { Forms } from 'constants/forms'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// types
import { IRiskTemplate, SystemProcessObject } from 'types/graphql'
// views
import { Button, Option, OptionWrapper, Wrapper } from './views'
// utils
import isEmpty from 'lodash/isEmpty'
import { getMetatagOptions, getRTMetatags } from 'utils/systemProcess'

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  },
  PaperProps: {
    style: {
      borderRadius: '4px',
      marginTop: '3px'
    }
  }
}

interface IProps {
  addMetatag: (metatag: string, closePopup: () => void) => void
  parentRiskTemplates: IRiskTemplate[]
  testId?: string
}

const AddMetatagButton: React.FC<IProps> = ({ addMetatag, parentRiskTemplates, testId }) => {
  const { metatag, object } = useSelector((state) => ({
    metatag: formValueSelector(Forms.METATAGS_SEARCH_FORM)(state, 'metatag'),
    object: formValueSelector(Forms.SYSTEM_PROCESS_CREATE_FORM)(state, 'object.value')
  }))

  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const metatags: any = React.useMemo(() => {
    const options =
      object === SystemProcessObject.RiskTemplate
        ? getRTMetatags(riskTemplate, parentRiskTemplates)
        : getMetatagOptions(object)

    if (metatag) {
      return options.map((item) => {
        const options = item.options.filter((option) => {
          if (metatag && option.label.includes(metatag)) {
            return option
          }
        })

        return {
          ...item,
          label: isEmpty(options) ? null : item.label,
          options: options
        }
      })
    } else {
      return options
    }
  }, [metatag, object, parentRiskTemplates?.length])

  if (!metatags || !metatags.length) {
    return null
  }

  return (
    <PopoverModal {...MODAL_PROPS} trigger={<Button data-testid={testId}>+ add metatag</Button>}>
      {({ closePopup }) => (
        <Wrapper>
          {metatags.map((item) => {
            return (
              <OptionWrapper key={item.label}>
                {item.label && <span>{item.label}</span>}
                {item.options.map((option) => {
                  return (
                    <Option
                      key={option.value}
                      data-testid='metatag-option'
                      data-entity-id={option.value}
                      onClick={() => addMetatag(option.value, closePopup)}>
                      {option.label}
                    </Option>
                  )
                })}
              </OptionWrapper>
            )
          })}
        </Wrapper>
      )}
    </PopoverModal>
  )
}

export default reduxForm<any, any>({
  form: Forms.METATAGS_SEARCH_FORM
})(AddMetatagButton)
